import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Layout from './components/layout/Layout';
import WorkflowsList from './components/workflows/WorkflowsList';
import WorkflowEditor from './components/workflows/WorkflowEditor';
import WorkflowSlugRunner from './components/workflows/WorkflowSlugRunner';
import QueuePage from './components/generation/QueuePage';
import HistoryPage from './components/generation/HistoryPage';
import JobDetailsPage from './components/generation/JobDetailsPage';
import DashboardPage from './components/dashboard/DashboardPage';
import ImageGallery from './components/gallery/ImageGallery';
import WorkflowSlugEditor from './components/admin/WorkflowSlugEditor';
import AdminDashboard from './components/admin/AdminDashboard';
import GeneratePage from './components/generation/GeneratePage';

const AppContent: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<GeneratePage />} />
        <Route
          path="/workflow/:id"
          element={<WorkflowEditor workflowId={window.location.pathname.split('/')[2]} />}
        />
        <Route
          path="/workflow-slug/:id"
          element={<WorkflowSlugRunner workflowId={window.location.pathname.split('/')[2]} />}
        />
        <Route path="/queue" element={<QueuePage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route
          path="/job/:id"
          element={<JobDetailsPage jobId={window.location.pathname.split('/')[2]} />}
        />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/gallery" element={<ImageGallery />} />
        <Route
          path="/gallery/:jobId"
          element={<ImageGallery jobId={parseInt(window.location.pathname.split('/')[2])} />}
        />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route
          path="/admin/workflow/:id/slug"
          element={<WorkflowSlugEditor workflowId={window.location.pathname.split('/')[3]} />}
        />
        <Route path="/admin/workflow/new-slug" element={<WorkflowSlugEditor />} />
        {/* Legacy routes kept for backward compatibility */}
        <Route path="/workflows" element={<WorkflowsList />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;
